<template>
  <el-config-provider size="default" :locale="locale">
    <RouterView />
  </el-config-provider>
</template>

<script lang="ts" setup>
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

const locale = ref(zhCn);
</script>
